import Layout from '@/components/feature/Layout';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import StatsSection from './components/StatsSection';
import VideoGrid from './components/VideoGrid';

export default function Home() {
  return (
    <Layout>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" />

      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <StatsSection />
      <VideoGrid />
    </Layout>
  );
}